import { Component, OnInit } from '@angular/core';
import { serviceURLService } from '../service/serviceURL';
import { Router } from '@angular/router';
import { TitleCasePipe } from '@angular/common';

import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';

@Component({
  selector: 'app-insurances',
  templateUrl: './insurances.component.html',
  styleUrls: ['./insurances.component.css']
})
export class InsurancesComponent implements OnInit {
  data: any ={};
  error: any;
  insuranceDetails: Array<any> = [];
  updatedTime : any;
  backgroundAttached: Array<any> = [];
  loading: boolean = false;
  private onDestroy$: Subject<void> = new Subject<void>();
  constructor(private serviceURLService: serviceURLService, private router: Router, private titlecasePipe:TitleCasePipe) { }

  ngOnInit() {
    this.insurance()
    
  }

  transformName(headerData){
    headerData = headerData.split(/(?=[A-Z])/).join(' ');
    return this.titlecasePipe.transform(headerData);
  }


  insurance(){
    this.loading = true;
    this.data = {
      "updatedTime": null,
      
    }
    this.backgroundAttached = []
    this.serviceURLService.insurance(this.data).pipe(takeUntil(this.onDestroy$)).subscribe((successData:any) => {
      this.insuranceDetails = successData.response.policies;
      for (let i = 0; i < (successData.response.policies).length; i++) {
        if((successData.response.policies[i].attachments).length > 0){          
          this.backgroundAttached.push({
            backgroundURL: successData.response.policies[i].attachments[0].nativePath
          })
        }
      }
      this.loading = false;
    }, errorData => {
      if(errorData.error.status === 401){
        this.router.navigate(['login']);
      }else if(errorData.error.status === 403){
        this.error = errorData.error.message;
      }
      console.log("not registered");
    })
  }
  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
    }
}
